import { Typography } from 'antd';
import { InfoWindow } from '@react-google-maps/api';
import React from 'react';
import * as PropTypes from 'prop-types';
import styles from './MarkerInfo.module.less';

const MarkerInfo = props => {
  const { position, onCloseClick, title, location } = props;
  return (
    <InfoWindow position={position} onCloseClick={onCloseClick}>
      <div className={styles.textContainer}>
        <div>
          <Typography.Text className={`${styles.smallText} ${styles.primaryColor}`}>{title}</Typography.Text>
        </div>
        <div>
          <Typography.Text>{location}</Typography.Text>
        </div>
      </div>
    </InfoWindow>
  );
};

MarkerInfo.propTypes = {
  position: PropTypes.object,
  onCloseClick: PropTypes.func,
  title: PropTypes.string,
  location: PropTypes.string
};
export default MarkerInfo;
